const Navbar = () => {
  return <></>;
};

export default Navbar;
